const development = "http://localhost:5000/"
const production = "https://api-iplmazenta.ciptaharmoni.com/"

export const  baseUrl = production